import React from 'react';

export const useCopyToClipboard = () => {
  const copiedTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const [textCopied, setTextCopied] = React.useState(false);

  React.useEffect(() => {
    return () => {
      copiedTimer.current && clearTimeout(copiedTimer.current);
    };
  }, []);

  const copyToClipboard = async (text: string, onCopied?: () => void) => {
    if (textCopied) {
      return;
    }

    try {
      await navigator.clipboard.writeText(text);

      setTextCopied(true);
      onCopied && onCopied();

      const TWO_SECONDS = 2000;
      copiedTimer.current = setTimeout(() => setTextCopied(false), TWO_SECONDS);
    } catch (error) {
      console.warn('Failed to copy text to clipboard:', error);
      return;
    }
  };

  return { copyToClipboard, textCopied };
};
